import BlogHeader from "../../components/blog-header/BlogHeader";
import BlogPosts from "../../components/RetiredComponents/blog-home-posts/BlogPosts";
import BlogSideBar from "../../components/blog-sidebar/BlogSideBar";
import Breadcrumbs from "../../components/navigation-components-blog/BreadcrumbNav"
import BlogFooter from "../../components/blog-footer/BlogFooter"
// Replaced by the Shop and Recipes sections below (HomePageDisplay); kept for reference.
// import HomePageButton from "../../components/blog-home-page-options/blogHomePageOptions"
import HomePageDisplay from "../../components/blog-home-page-options-v2/blogHomePageOptionsV2"
import React from 'react';
import './bloghome.scss'
import BlogHeaderV2 from "../../components/blog-header/BlogHeaderV2";

function BlogHome() {
    return(
        <>
            <div className="blog-home-main">
                {/*<BlogHeader TitleSmall = "blog" TitleLarge = "Blog Maria"/>*/}
                <BlogHeaderV2/>
                {/*<div className="blog-home-outer">
                        <HomePageButton/>
                </div>*/}
                <HomePageDisplay/>
                <BlogFooter/>
            </div>
        </>
    )
}

export default BlogHome;